import { useTranslation } from "react-i18next";
import "./legal.css";

export function Privacy() {
  const { t } = useTranslation();
  return (
    <article className="container legal">
      <h1>{t("privacy.title")}</h1>
      <p className="legal__updated">{t("privacy.lastUpdated")}</p>
      <p>{t("privacy.intro")}</p>

      <h2>{t("privacy.controllerTitle")}</h2>
      <p>{t("privacy.controllerBody")}</p>

      <h2>{t("privacy.dataTitle")}</h2>
      <p>{t("privacy.dataBody")}</p>

      <h2>{t("privacy.logsTitle")}</h2>
      <p>{t("privacy.logsBody")}</p>

      <h2>{t("privacy.minorsTitle")}</h2>
      <p>{t("privacy.minorsBody")}</p>

      <h2>{t("privacy.lawfulTitle")}</h2>
      <p>{t("privacy.lawfulBody")}</p>

      <h2>{t("privacy.retentionTitle")}</h2>
      <p>{t("privacy.retentionBody")}</p>

      <h2>{t("privacy.rightsTitle")}</h2>
      <p>{t("privacy.rightsBody")}</p>

      <h2>{t("privacy.thirdPartyTitle")}</h2>
      <p>{t("privacy.thirdPartyBody")}</p>

      <h2>{t("privacy.aiTitle")}</h2>
      <p>{t("privacy.aiBody")}</p>

      <h2>{t("privacy.cookiesTitle")}</h2>
      <p>{t("privacy.cookiesBody")}</p>
    </article>
  );
}
